module.exports = __webpack_public_path__ + "img/GS1_Symbol_Info_Sign_RGB_2015-04-16.11eb86a6.png";